import { groupByDictUnique } from '../../common/utils';
import { Expansion, ExpansionLevelCap, ExpansionPatch } from '../expansion';
import { generateGetSeasonBySlug, getSeasonByEventId, getSortedSeasons } from '../mythicPlus';
import { Difficulty, FeatureFlag, UserConnectionType } from '../sharedTypes';
import { SEASONS } from '../wowclassic/mythicPlus';
import { WOWERA_EVENT_CONFIG } from './events';
import { QUALIFIED_GUILD_RECRUITMENT_TAGS } from './qualifiedGuildRecruitmentTags';
import { RAID_METADATA } from './raids';
import { WOW_ERA_ROUTES } from './routes';
import { IEraGameConfig } from './types';

const RAID_DIFFICULTIES: Difficulty[] = [
  // {
  //   id: WoWDifficultyId.NORMAL_RAID,
  //   slug: RaidDifficulty.NORMAL,
  //   name: 'Normal',
  //   acronym: 'N',
  //   maxMembers: 30
  // },
  // {
  //   id: WoWDifficultyId.HEROIC_RAID,
  //   slug: RaidDifficulty.HEROIC,
  //   name: 'Heroic',
  //   acronym: 'H',
  //   maxMembers: 30
  // },
  // {
  //   id: WoWDifficultyId.MYTHIC_RAID,
  //   slug: RaidDifficulty.MYTHIC,
  //   name: 'Mythic',
  //   acronym: 'M',
  //   maxMembers: 20
  // }
];

const config: IEraGameConfig = {
  SiteBackdropPath: '/images/site/classic_backdrop.png',

  //
  // Expansion Settings
  //
  CurrentExpansion: Expansion.ClassicEra,
  NextExpansion: Expansion.ClassicEra,
  PreviousExpansion: Expansion.ClassicEra,
  FirstSupportedExpansion: Expansion.ClassicEra,

  //
  // Patch Settings
  //
  CurrentPatch: ExpansionPatch.Patch_1026,
  FirstSupportedPatch: ExpansionPatch.Patch_700,
  PublicTestRealmPatch: ExpansionPatch.Patch_1026,
  BetaPatch: ExpansionPatch.Patch_1100,

  CurrentLevelCap: ExpansionLevelCap.Classic,
  PreviousLevelCap: ExpansionLevelCap.Classic,
  MinScanLevel: 10,

  RaidDifficulties: RAID_DIFFICULTIES,

  Raids: RAID_METADATA,
  RaidsBySlug: groupByDictUnique(RAID_METADATA, 'slug'),

  MythicPlusSeasons: SEASONS,
  MythicPlusSeasonsSorted: getSortedSeasons(SEASONS),
  MythicPlusSeasonsByPartitionEventId: getSeasonByEventId(SEASONS),

  getSeasonBySlug: generateGetSeasonBySlug([], {}),

  Routes: WOW_ERA_ROUTES,

  Expansions: [],
  getExpansionById: () => {
    throw new Error('Not implemented');
  },
  getExpansionBySlug: () => {
    throw new Error('Not implemented');
  },

  BaselineFeatures: [
    FeatureFlag.AC_QUEUE,
    FeatureFlag.AC_DOCKING,
    FeatureFlag.AC_DOCKING_CHARACTER,
    FeatureFlag.AC_DOCKING_GUILD,
    FeatureFlag.RECRUITMENT,
    FeatureFlag.RECRUITMENT_VIEW,
    // FeatureFlag.RECRUITMENT_SEARCH,
    FeatureFlag.RECRUITMENT_CREATE,
    FeatureFlag.MESSAGE_CENTER,
    FeatureFlag.MANAGE_RAID_ENCOUNTER_VIDEOS,
    FeatureFlag.MANAGE_KEYSTONE_RUN_VIDEOS
  ],

  UserConnectionTypes: [
    UserConnectionType.DISCORD,
    UserConnectionType.TWITCH,
    UserConnectionType.YOUTUBE,
    UserConnectionType.DOUYU
  ],

  ItemSlotGroups: [
    ['head'],
    ['neck'],
    ['shoulder'],
    ['back'],
    ['chest'],
    ['shirt'], // classic
    ['wrist'],
    ['hands'],
    ['waist'],
    ['legs'],
    ['feet'],
    ['finger1'],
    ['finger2'],
    ['trinket1', 'trinket2'],
    ['mainhand'],
    ['offhand'],
    ['ranged'] // classic
  ],

  EventConfig: WOWERA_EVENT_CONFIG,

  QualifiedGuildRecruitmentTags: QUALIFIED_GUILD_RECRUITMENT_TAGS
};

export default config;
